import * as React from "react";
import { Link } from "react-router";
import styled, { css } from "styled-components";
import { ControlArrowRightDark } from "./icons/Arrows";

const BoldLinkStyles = css`
  display: inline-flex;
  align-items: flex-end;
  font-size: ${({ theme }) => theme.fontSizes[1]};
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledBoldLink = styled(Link)`
  ${BoldLinkStyles}
`;

interface IBoldLinkProps {
  children: React.ReactNode;
  to: string;
}

type IProps = IBoldLinkProps;

const BoldLink: React.FC<IProps> = ({ children, to }) => (
  <StyledBoldLink to={to}>
    {children}
    <ControlArrowRightDark />
  </StyledBoldLink>
);

export default BoldLink;
